/**
 * Gets a link for a specified page/request
 *
 * @param {string}  url    The base url
 * @param {Object=} params Object of parameters for the URL
 *
 * @returns {string} Returns the requested URL
 */
export const buildURL = (url, params = {}) => {
    const query = [];

    // create an array of params
    for (const param of Object.keys(params)) {
        query[query.length] = `${encodeURIComponent(param)}=${encodeURIComponent(params[param])}`;
    }

    return url + (query.length > 0 ? `?${query.join('&').replace(/%20/g, '+')}` : '');
};
